<!-- 用于展示监测点信息包括锚点 -->
<template>
    <div class="h-100">
        <span class="uk-flex uk-flex-between uk-flex-middle" style="margin-bottom:2px;">
            <span>
                <i :class="{ 'el-icon-turn-off': !tab, 'el-icon-open green': tab }" @click="switchPoint"
                    style="font-size:18px" :title="$t('integration.open_anchor')"></i>
            </span>

            <span>
                <i v-icon="['carrierTypeConvert', carrier.typeId]"></i>
                <i v-icon="['carrierStatusConvert', carrier.status]"></i>
                <!-- <i v-icon="['traceConvert', carrier.is_trace]"></i> -->
                <!-- <i v-icon="['isAlarmConvert', carrier.alarm_switch]"></i> -->
            </span>
        </span>
        <AnchorImg style="height:calc(100% - 20px)" :posiList="carrier.carrierPosition"
            :deviceList="carrier.carrierDevice.deviceList"
            :carrierImg="carrier.carrierExtend && carrier.carrierExtend.pictureBase64" :anchorShow="tab || false">
        </AnchorImg>
    </div>
</template>
<script>
import AnchorImg from '@/pages/dataBoard/MonitoringPoint/component/DisplayArea/component/component/AnchorImg';
export default {
    props: ['carrier', 'tab'],
    components: {
        AnchorImg
    },
    methods: {
        switchPoint() {
            this.$emit('update:tab', !this.tab);
        }
    }
};
</script>

<style scoped lang="scss">
$switch-active-color: #344962;

.green {
    color: $switch-active-color;
}

.el-icon-turn-off {
    color: #ccc;
}
</style>
